
import { jsPDF } from "jspdf";
import { PdfScoreOptions } from "./types";

/**
 * Get score category based on percentage
 */
export const getScoreCategory = (percentage: number): string => {
  if (percentage >= 76) return "Excellent";
  if (percentage >= 51) return "High";
  if (percentage >= 26) return "Moderate";
  return "Low";
};

/**
 * Get readiness tier text
 */
export const getReadinessTier = (percentage: number): string => {
  if (percentage >= 76) return "Excellent Readiness";
  if (percentage >= 51) return "High Readiness";
  if (percentage >= 26) return "Moderate Readiness";
  return "Low Readiness";
};

/**
 * Get score color in RGB format
 */
export const getScoreColor = (percentage: number): number[] => {
  if (percentage >= 76) return [39, 174, 96]; // green
  if (percentage >= 51) return [41, 128, 185]; // blue
  if (percentage >= 26) return [243, 156, 18]; // yellow
  return [231, 76, 60]; // red
};

/**
 * Get score interpretation text
 */
export const getScoreInterpretation = (percentage: number): string => {
  if (percentage >= 76) {
    return "Your board demonstrates excellent AI governance readiness. You have established key structures, policies, and oversight mechanisms for responsible AI use. Continue to refine your approach as AI technologies and regulations evolve.";
  }
  if (percentage >= 51) {
    return "Your board has high AI governance readiness. With some targeted improvements in specific areas, you can enhance your ability to address AI challenges. Focus on the improvement areas identified in this report.";
  }
  if (percentage >= 26) {
    return "Your board has moderate AI governance readiness with several areas needing attention. Consider prioritizing the improvement recommendations to strengthen your AI oversight capabilities.";
  }
  return "Your board has low AI governance readiness. There are significant opportunities to strengthen your oversight capabilities. The recommendations in this report provide a starting point for developing effective AI governance.";
};

/**
 * Add score visualization to PDF
 */
export const addScoreVisualization = ({ doc, percentage, pageWidth, y }: PdfScoreOptions): number => {
  const scoreCategory = getScoreCategory(percentage);
  const readinessTier = getReadinessTier(percentage);
  const scoreColor = getScoreColor(percentage);
  
  // Add score visualization
  doc.setFillColor(scoreColor[0], scoreColor[1], scoreColor[2]);
  doc.circle(40, y, 15, "F");
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(14);
  doc.text(`${percentage}%`, 40, y, { align: "center" });
  
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(14);
  doc.text(`${readinessTier}`, 70, y);
  
  doc.setFontSize(12);
  doc.text("AI Governance Readiness Score", 70, y + 10);
  
  return y + 30; // Return the new y position
};
